import React from 'react';
import { useSelector } from 'react-redux';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import { sidebars } from '../../store/actions/sidebar.actions';

function SideCartEmpty() {
    const activeSidebar = useSelector((state) => state.sidebar.active);
    const oneColumnPage = useSelector(state => state.common.oneColumnPage);

    return (
        <div id="sideCart" className={classNames('col sidebar as-shadow cart-sidebar d-none pb-2 pb-md-0 d-xl-block', {show: activeSidebar === sidebars.cart})}>
            <div className="cart-details">
                <h2 className="title">Cart</h2>
                <div className="cart-items">
                    <div className="cart-items-header">
                        <div>Qty</div>
                        <div>Item</div>
                        <div>Amount</div>
                    </div>
                    <div className="cart-empty">
                        <div className="text-center">
                            {/*<h1 className="text-uppercase">Choose an item</h1>*/}
                            {/*<p><i className="fas fa-shopping-bag" style={{fontSize: '90px'}}></i></p>*/}
                            <p><i className="fas fa-shopping-cart" style={{fontSize: '90px'}}></i></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(SideCartEmpty);